module.exports = __webpack_public_path__ + "img/7.ec85cfa5.svg";